var React = require('react');

function Ok (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",{"transform":"translate(-555.293 -682.712)"},React.createElement("path",{"d":"M816.244,4359l4.182,4.182,8.762-8.763","transform":"translate(-260.244 -3671)","fill":"none","stroke":"#000","strokeWidth":"2"}))));
}

Ok.defaultProps = {"width":"14.359","height":"10.884","viewBox":"0 0 14.359 10.884"};

module.exports = Ok;

Ok.default = Ok;
